export const urlBuilder = (...args: Array<string | number>) => {
    const joined = args.join('/');
    return joined.startsWith('/') ? joined : '/' + joined;
};
